export default "__VITE_ASSET__ClB6UUv8__"